import React from 'react';
import { SendOutlined, SettingOutlined } from '@ant-design/icons';

export interface MenuItemConfig {
  key: string;
  icon: React.ReactNode;
  label: string;
  children?: { key: string; label: string }[];
}

export const topMenuConfig: MenuItemConfig[] = [
  {
    key: '/shipments',
    icon: <SendOutlined />,
    label: 'Shipment',
    children: [{ key: '/shipments/list', label: 'Shipment list' }],
  },
  {
    key: '/settings',
    icon: <SettingOutlined />,
    label: 'Settings',
    children: [{ key: '/settings/account', label: 'Account' }],
  },
];
